var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.902 11C13.014 10.497 13.22 10.074 13.745 9.624C13.8158 9.56349 13.8908 9.50327 13.9675 9.44167C14.4499 9.0543 15 8.61252 15 7.704C15 6.011 13.879 5 12 5C10.346 5 9 6.346 9 8H10.804C10.804 7.396 11.031 6.502 12 6.502C12.969 6.502 13.101 7.067 13.101 7.704C13.101 8.07149 12.7507 8.36688 12.1578 8.86674C12.1069 8.9096 12.0543 8.95396 12 9C11.313 9.583 11.098 10.151 11.098 11H12.902Z",
    fill: "#4F49DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13C10.75 13.691 11.309 14.25 12 14.25C12.69 14.25 13.25 13.691 13.25 13C13.25 12.31 12.69 11.75 12 11.75C11.309 11.75 10.75 12.31 10.75 13Z",
    fill: "#4F49DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0476 2H3.00251C2.73663 2 2.48163 2.10544 2.29363 2.29313C2.10562 2.48082 2 2.73539 2 3.00082V21.0156C2.00056 21.2004 2.05237 21.3814 2.1497 21.5387C2.24702 21.6959 2.38605 21.8231 2.55138 21.9063C2.7116 21.9809 2.88872 22.0118 3.06478 21.996C3.24084 21.9802 3.40958 21.9181 3.55389 21.8162L8.70677 18.0131H20.9975C21.2634 18.0131 21.5184 17.9077 21.7064 17.72C21.8944 17.5323 22 17.2777 22 17.0123V3.00082C22.0003 2.74383 21.9016 2.49657 21.7243 2.31025C21.547 2.12394 21.3047 2.01285 21.0476 2ZM20.0451 16.0115H8.42607C8.21259 16.0136 8.00537 16.0837 7.83459 16.2116L4.00501 19.034V4.02166H20.0451V16.0115Z",
    fill: "#4F49DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.95516da6.svg";
export { ForwardRef as ReactComponent };